export * from './header/header.component';
export * from './footer/footer.component';
export * from './search-input/search-input.component';
export * from './theme-settings/theme-settings.component';
export * from './theme-switcher/theme-switcher.component';



// WEBPACK FOOTER //
// /app/src/app/@theme/components/index.ts